import {
  IconCommentFill,
  IconMultiFlag,
  IconMultiShare,
  IconPencilFill,
  IconPersonFill,
  IconTrashcanFill,
} from '@snorose/icons';

const POST_MORE_OPTION_LIST = [
  {
    modalId: null,
    icon: IconMultiFlag,
    label: '게시글 신고',
    width: 19,
    height: 22,
  },
  {
    modalId: null,
    iconId: 'report-user',
    label: '이용자 신고하기',
    width: 24,
    height: 24,
    icon: IconPersonFill,
    color: 'var(--blue-3)',
  },
  {
    modalId: 'share',
    iconId: 'share',
    label: '공유하기',
    width: 24,
    height: 24,
    icon: IconMultiShare,
  },
];

const MY_POST_MORE_OPTION_LIST = [
  {
    modalId: null,
    iconId: 'pencil-blue',
    label: '수정하기',
    width: 19,
    height: 22,
    icon: IconPencilFill,
    color: 'var(--blue-3)',
  },
  {
    modalId: 'confirm-post-delete',
    iconId: 'trash',
    label: '삭제하기',
    width: 24,
    height: 24,
    icon: IconTrashcanFill,
    color: 'var(--pink-2)',
  },
  {
    modalId: 'share',
    iconId: 'share',
    label: '공유하기',
    width: 24,
    height: 24,
    icon: IconMultiShare,
  },
];

const EXAM_REVIEW_MORE_OPTION_LIST = [
  {
    modalId: null,
    icon: IconMultiFlag,
    label: '시험후기 신고',
    width: 24,
    height: 24,
  },
  {
    modalId: null,
    iconId: 'report-user',
    label: '이용자 신고하기',
    width: 24,
    height: 24,
    icon: IconPersonFill,
    color: 'var(--blue-3)',
  },
];

const MY_EXAM_REVIEW_MORE_OPTION_LIST = [
  {
    modalId: null,
    iconId: 'pencil-blue',
    label: '수정하기',
    width: 19,
    height: 22,
    icon: IconPencilFill,
    color: 'var(--blue-3)',
  },
  {
    modalId: 'confirm-exam-review-delete',
    iconId: 'trash',
    label: '삭제하기',
    width: 24,
    height: 24,
    icon: IconTrashcanFill,
    color: 'var(--pink-2)',
  },
];

const COMMENT_MORE_OPTION_LIST = [
  {
    modalId: null,
    iconId: 'report-comment',
    label: '댓글 신고',
    width: 21,
    height: 22,
    icon: IconCommentFill,
    color: 'var(--blue-3)',
  },
  {
    modalId: null,
    iconId: 'report-user',
    label: '이용자 신고하기',
    width: 24,
    height: 24,
    icon: IconPersonFill,
    color: 'var(--blue-3)',
  },
];

const MY_COMMENT_MORE_OPTION_LIST = [
  {
    modalId: null,
    iconId: 'pencil-blue',
    label: '수정하기',
    width: 19,
    height: 22,
    icon: IconPencilFill,
    color: 'var(--blue-3)',
  },
  {
    modalId: 'confirm-comment-delete',
    iconId: 'trash',
    label: '삭제하기',
    width: 24,
    height: 24,
    icon: IconTrashcanFill,
    color: 'var(--pink-2)',
  },
];

const EVENT_MORE_OPTION_LIST = [
  {
    modalId: 'share',
    iconId: 'share',
    label: '공유하기',
    width: 24,
    height: 24,
    icon: IconMultiShare,
  },
];

// =================== Confirm Modal ===================
const CONFIRM_MODAL = {
  // 게시글 관련 확인 모달
  DELETE_POST: {
    title: '게시글을 삭제할까요?',
    description: '게시글을 삭제하면<br /> 지급된 포인트가 차감돼요',
    confirmText: '삭제',
    cancelText: '취소',
  },
  DELETE_POST_WITHOUT_POINT_DEDUCTION: {
    title: '게시글을 삭제할까요?', // 베숙트 게시글 삭제는 포인트 차감 없음
    description: null,
    confirmText: '삭제',
    cancelText: '취소',
  },

  // 시험후기 관련 확인 모달
  DELETE_EXAM_REVIEW: {
    title: '시험후기를 삭제할까요?',
    description: '삭제 시 포인트가 차감돼요',
    confirmText: '삭제',
    cancelText: '취소',
  },
  EXAM_REVIEW_DUPLICATION: {
    title: `중복 후기가 있어요<br />계속 업로드할까요?`,
    description: `<span style="font-size: 14px; white-space: nowrap;">중복 후기의 경우, 먼저 올라온 후기보다<br /> 더 많은 문제가 기록된 경우만 허용돼요.<br />이외 모든 족보는 무통보 삭제되며 <br />포인트 회수 및 <span style="color: #FF4B6C;">경고 1회</span>가 부여돼요.</span>`,
    confirmText: '확인',
    cancelText: '취소',
  },
  EXAM_REVIEW_DOWNLOAD: {
    title: '다운로드할까요?',
    description:
      '<p style="font-size: 16px; color: #484848;">다운로드시 50 포인트가 차감돼요</p><p style="margin-top: 8px; font-size: 14px; color: #484848;">원활한 이용을 위해 Chrome 또는 \nEdge브라우저 사용을 권장해요.</p>',
    confirmText: '확인',
    cancelText: '취소',
  },

  // 댓글 관련 확인 모달
  DELETE_COMMENT: {
    title: '댓글을 삭제할까요?',
    description: '댓글을 삭제하면<br />지급된 포인트가 차감돼요',
    confirmText: '삭제',
    cancelText: '취소',
  },
  DELETE_COMMENT_WITHOUT_POINT_DEDUCTION: {
    title: '댓글을 삭제할까요?', // 시험후기 댓글 삭제는 포인트 차감 없음
    description: null,
    confirmText: '삭제',
    cancelText: '취소',
  },

  // 문의 및 신고 확인 모달
  INQUIRY_CREATE: {
    title: '문의 작성을 완료할까요?',
    description: `관리자 답변이 등록되면\n수정 및 삭제가 불가능해요`,
    confirmText: '완료',
    cancelText: '취소',
  },
  INQUIRY_UPDATE: {
    title: '문의 수정을 완료할까요?',
    description: `관리자 답변이 등록되면\n수정 및 삭제가 불가능해요`,
    confirmText: '완료',
    cancelText: '취소',
  },
  REPORT_CREATE: {
    title: '신고를 완료할까요?',
    description: `관리자 답변이 등록되면\n수정 및 삭제가 불가능해요`,
    confirmText: '완료',
    cancelText: '취소',
  },
  REPORT_UPDATE: {
    title: '신고 수정을 완료할까요?',
    description: `관리자 답변이 등록되면\n수정 및 삭제가 불가능해요`,
    confirmText: '완료',
    cancelText: '취소',
  },

  // 유저 관련 확인 모달
  WITHDRAW_ACCOUNT: {
    title: '정말 탈퇴하시겠습니까?',
    description: null,
    confirmText: '확인',
    cancelText: '취소',
  },

  // etc 확인 모달
  EXIT_PAGE: {
    title: '작성 중인 글을 삭제할까요?',
    description: '지금까지 작성한 내용은\n저장되지 않아요',
    confirmText: '삭제',
    cancelText: '취소',
  },
  ACCESS_DENIED: {
    title: null,
    description: '인증 페이지로 이동할까요?',
    confirmText: '네',
    cancelText: '아니요',
  },

  // 시험 후기 확인 모달
  EXAM_EXIT_PAGE: {
    title: '작성 중인 시험후기를 삭제할까요?',
    description: '지금까지 작성한 내용은\n저장되지 않아요',
    confirmText: '삭제',
    cancelText: '취소',
  },

  // 알림 해제 모달
  DISABLE_NOTIFICATION: {
    title: '알림을 끌까요?',
    description:
      '알림을 끄시면 강등, 무통보 삭제 등의\n중요한 안내를 받지 못해요',
    confirmText: '끄기',
    cancelText: '취소',
  },
};

// =================== Notice Modal ===================
const NOTICE_MODAL = {
  ALREADY_VERIFIED: {
    title: '인증이 필요하지 않아요',
    description: '이미 인증을 완료했거나 인증 대상이 아니에요.',
    confirmText: '홈으로 이동',
  },
  ALREADY_ANSWERED: {
    title: '이미 답변이 완료되었어요',
    description: '답변이 등록된 문의글은 수정할 수 없어요',
    confirmText: '돌아가기',
  },
  NOT_POST_AUTHOR: {
    title: '접근 권한이 없어요',
    description: '내가 작성한 글이 아니에요',
    confirmText: '돌아가기',
  },
  MAEKETING_NOTICE_MODAL: {
    id: 'marketing-notice',
    title: (isMarketingAgreed) =>
      isMarketingAgreed
        ? '광고성 정보 수신 동의 완료'
        : '광고성 정보 수신 동의 해제 완료',
    description: (isMarketingAgreed, date) =>
      isMarketingAgreed
        ? `${date}\n\n매체 : 앱 푸시\n목적 :  마케팅 정보 수신\n수신거부 : 알림 설정에서 수신 거부 가능`
        : date,
    confirmText: '닫기',
  },
};

// 첨부파일 모달
const ATTACHMENT_MODAL = {
  DELETE_ATTACHMENT: {
    title: '삭제하시겠습니까?',
    confirmText: '삭제',
    cancelText: '취소',
  },
};

export const MORE_OPTION_MODAL_TEXT = {
  POST_MORE_OPTION_LIST,
  MY_POST_MORE_OPTION_LIST,
  EXAM_REVIEW_MORE_OPTION_LIST,
  MY_EXAM_REVIEW_MORE_OPTION_LIST,
  COMMENT_MORE_OPTION_LIST,
  MY_COMMENT_MORE_OPTION_LIST,
  EVENT_MORE_OPTION_LIST,
};

export const CONFIRM_MODAL_TEXT = CONFIRM_MODAL;
export const NOTICE_MODAL_TEXT = NOTICE_MODAL;
export const ATTACHMENT_MODAL_TEXT = ATTACHMENT_MODAL;
